module.exports = __webpack_public_path__ + "img/aiot_bg1.70f60b70.png";